export const PERMISSIONS = {
  view: 'professional_assessment.view',
  patternsManage: 'professional_assessment.patterns.manage',
  sectionsManage: 'professional_assessment.sections.manage',
  questionsManage: 'professional_assessment.questions.manage',
  weightsManage: 'professional_assessment.weights.manage',
  versionsManage: 'professional_assessment.versions.manage',
  questionnaireExport: 'professional_assessment.workbooks.questionnaire.export',
  questionnaireImport: 'professional_assessment.workbooks.questionnaire.import',
  topThreeProfilesView: 'professional_assessment.top_three_profiles.view',
  topThreeProfilesManage: 'professional_assessment.top_three_profiles.manage',
  topThreeProfilesExport: 'professional_assessment.workbooks.top_three_profiles.export',
  topThreeProfilesImport: 'professional_assessment.workbooks.top_three_profiles.import',
  resultContentView: 'professional_assessment.result_content.view',
  resultContentManage: 'professional_assessment.result_content.manage',
  tagsManage: 'professional_assessment.tags.manage',
  attemptsView: 'professional_assessment.attempts.view',
  specialistsView: 'professional_assessment.specialists.view',
  specialistsManage: 'professional_assessment.specialists.manage',
  consultationsView: 'professional_assessment.consultations.view',
  consultationsManage: 'professional_assessment.consultations.manage',
  notificationsView: 'professional_assessment.notifications.view',
  notificationsManage: 'professional_assessment.notifications.manage',
  supportView: 'professional_assessment.support.view',
  supportManage: 'professional_assessment.support.manage',
  legalDocumentsView: 'professional_assessment.legal_documents.view',
  legalDocumentsManage: 'professional_assessment.legal_documents.manage',
  plansView: 'professional_assessment.plans.view',
  plansManage: 'professional_assessment.plans.manage',
  companiesView: 'professional_assessment.companies.view',
  companiesManage: 'professional_assessment.companies.manage',
  purchasesView: 'professional_assessment.purchases.view',
  purchasesManage: 'professional_assessment.purchases.manage',
  entitlementsView: 'professional_assessment.entitlements.view',
  entitlementsManage: 'professional_assessment.entitlements.manage',
  codesView: 'professional_assessment.codes.view',
  codesManage: 'professional_assessment.codes.manage',
  sponsoredResultsView: 'professional_assessment.sponsored_results.view',
};

function isAdminRecord(value) {
  return Boolean(value) && typeof value === 'object' && !Array.isArray(value);
}

function readPermissionSlug(item) {
  if (typeof item === 'string') {
    return item;
  }
  if (!item || typeof item !== 'object') {
    return '';
  }
  return item.slug || item.name || item.permission || '';
}

export function normalizeAdmin(payload = null) {
  if (!isAdminRecord(payload)) {
    return {
      id: null,
      name: '',
      permissions: [],
      is_super_admin: false,
    };
  }

  const root = payload.data && isAdminRecord(payload.data) && !Array.isArray(payload.data)
    ? payload.data
    : payload;
  const source = root.admin && isAdminRecord(root.admin) ? { ...root, ...root.admin } : { ...root };
  const permissionSource = Array.isArray(source.permissions)
    ? source.permissions
    : (Array.isArray(root.permissions) ? root.permissions : []);

  return {
    ...source,
    permissions: permissionSource.map(readPermissionSlug).filter(Boolean),
    is_super_admin: source.is_super_admin === true || source.isSuperAdmin === true,
  };
}

export function isSuperAdmin(admin) {
  return isAdminRecord(admin) && admin.is_super_admin === true;
}

export function hasPermission(adminOrPermissions, slug) {
  if (!slug) {
    return false;
  }
  if (isSuperAdmin(adminOrPermissions)) {
    return true;
  }
  const list = isAdminRecord(adminOrPermissions)
    ? adminOrPermissions.permissions
    : adminOrPermissions;
  return Array.isArray(list) && list.includes(slug);
}

export function hasAnyPermission(adminOrPermissions, slugs = []) {
  return slugs.some((slug) => hasPermission(adminOrPermissions, slug));
}
